import debug from "debug";

const log = debug("app:loading");

export default class LoadingOverlay {
    constructor(experience){
        this.eventHub = experience.eventHub;
        this.activeLoadingOperations = new Set(); // Track multiple loading operations

        this.setupEventListeners();
        this.showLoadingOverlay();
        

        this.loadingFinished = false;
    }

    cleanup() {
      console.log("Cleaning up LoadingOverlay: Removing event listeners and overlay.");
  
      this.eventHub.off("loading-finished", this.hideLoadingOverlay);
  
      if (this.overlay) {
          this.overlay.remove();
          this.overlay = null;
      }
  
      console.log("LoadingOverlay cleanup complete.");
  }
    
    setupEventListeners(){
        this.eventHub.on("loading-finished", () => this.hideLoadingOverlay());
        this.eventHub.on("part-loading-start", (data) => this.showPartLoadingSpinner(data));
        this.eventHub.on("part-loading-end", (data) => this.hidePartLoadingSpinner(data));
    }
    
    showLoadingOverlay() {
      // Create the overlay element
      const overlay = document.createElement('div');
      overlay.classList.add('loadingOverlay'); // Add the class "loadingOverlay"
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      overlay.style.display = 'flex';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';
      overlay.style.zIndex = '9999';
      overlay.setAttribute('id', 'loadingOverlay');
      
      // Create the loader element (spinner)
      const loader = document.createElement('div');
      loader.style.border = '8px solid #f3f3f3'; // Light gray
      loader.style.borderTop = '8px solid #FFA400'; // Orange top color
      loader.style.borderRadius = '50%';
      loader.style.width = '50px';
      loader.style.height = '50px';
      loader.style.animation = 'spin 1s linear infinite';
      
      // Create the loading text
      const loadingText = document.createElement('p');
      loadingText.textContent = 'Loading...';
      loadingText.style.color = 'white';
      loadingText.style.fontSize = '20px';
      loadingText.style.marginTop = '10px';
      
      // Append loader and text to overlay
      overlay.appendChild(loader);
      overlay.appendChild(loadingText);
      
      // Append the overlay to the body
      document.body.appendChild(overlay);
      // Simulate loading (remove the overlay after 3 seconds)
      /*setTimeout(() => {
        overlay.style.display = 'none'; // Hide the overlay
        //alert('Data loaded!');
      }, 3000); // Simulating loading for 3 seconds */
      this.overlay = overlay;
    }

    hideLoadingOverlay(){
        const overlay = document.querySelector('.loadingOverlay');
        if (overlay) {
            overlay.remove(); // Remove the overlay from the DOM
        }
    }

    showPartLoadingSpinner(data = {}) {
        log('Showing part loading spinner:', data);
        const loadingId = data.id || 'default-part-loading';
        this.activeLoadingOperations.add(loadingId);
        
        // Create or show the part loading overlay
        let overlay = document.querySelector('.part-loading-overlay');
        if (!overlay) {
            overlay = this.createPartLoadingOverlay();
        }
        overlay.style.display = 'flex';
        
        // Update loading text if provided
        if (data.text) {
            const loadingText = overlay.querySelector('.part-loading-text');
            if (loadingText) {
                loadingText.textContent = data.text;
            }
        }
    }

    hidePartLoadingSpinner(data = {}) {
        log('Hiding part loading spinner:', data);
        const loadingId = data.id || 'default-part-loading';
        this.activeLoadingOperations.delete(loadingId);
        
        // Only hide if no active loading operations
        if (this.activeLoadingOperations.size === 0) {
            log('All loading operations complete, hiding spinner');
            const overlay = document.querySelector('.part-loading-overlay');
            if (overlay) {
                overlay.style.display = 'none';
            }
        } else {
            log(`Still ${this.activeLoadingOperations.size} loading operations active`);
        }
    }

    createPartLoadingOverlay() {
        // Create the overlay element
        const overlay = document.createElement('div');
        overlay.classList.add('part-loading-overlay');
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
        overlay.style.display = 'none';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        overlay.style.zIndex = '8999'; // Slightly lower than main loading overlay
        overlay.style.pointerEvents = 'none'; // Allow interaction with underlying UI
        overlay.setAttribute('id', 'partLoadingOverlay');
        
        // Create container for spinner and text
        const container = document.createElement('div');
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.alignItems = 'center';
        container.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
        container.style.padding = '20px';
        container.style.borderRadius = '8px';
        container.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
        
        // Create the loader element (spinner) using existing CSS
        const loader = document.createElement('div');
        loader.style.border = '4px solid #f3f3f3';
        loader.style.borderTop = '4px solid #FFA400';
        loader.style.borderRadius = '50%';
        loader.style.width = '40px';
        loader.style.height = '40px';
        loader.style.animation = 'spin 1s linear infinite';
        
        // Create the loading text
        const loadingText = document.createElement('p');
        loadingText.classList.add('part-loading-text');
        loadingText.textContent = 'Loading part...';
        loadingText.style.color = '#333';
        loadingText.style.fontSize = '16px';
        loadingText.style.marginTop = '12px';
        loadingText.style.marginBottom = '0';
        
        // Append loader and text to container
        container.appendChild(loader);
        container.appendChild(loadingText);
        
        // Append container to overlay
        overlay.appendChild(container);
        
        // Append the overlay to the body
        document.body.appendChild(overlay);
        
        return overlay;
    }
    
    // Add the spinner animation via JS
    /*style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);*/
}
